import {ProfileView} from "@src/pages/settings/profile-view";
import {createFileRoute, useParams} from "@tanstack/react-router";
import {useProfile} from "@zeg/instant/w/useSettings";
import {TProfile} from "@zeg/instant/types";

export const Route = createFileRoute(
  "/_auth/_settings-layout/$workspaceSlug/settings/profile"
)({component: RouteComponent});

function RouteComponent() {
  const {workspaceSlug} = useParams({
    from: "/_auth/_settings-layout/$workspaceSlug/settings/profile",
  });
  const {data, isLoading, error} = useProfile(workspaceSlug as string);
  const profile = data?.workspaces[0].profiles[0] as unknown as TProfile;
  return (
    <ProfileView
      profile={profile}
      isLoading={isLoading}
      error={error as Error}
    />
  );
}
